import { Typography } from '@mui/material';
import { styledEditionalText } from './AdditionalSectionText.styled';
import { ReactNode } from 'react';

interface AdditionalSectionTextProps {
  children: ReactNode;
}

export default function AdditionalSectionText({
  children,
}: AdditionalSectionTextProps) {
  return (
    <Typography variant="body5" sx={styledEditionalText}>
      {children}
    </Typography>
  );
}
